module.exports = __webpack_public_path__ + "img/un_state.fb014b4c.png";